import { useState } from "react";
import './Styles/reel.css';
import LoadingAnimation from "./LoadingAnimation";
import SearchForm from "./Header/SearchForm";
import LoadedReels from "./LoadedResponses/LoadedReels";

const Reels = (props) => {
    const [reelUrl, setReelUrl] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [responseObj, setResponseObj] = useState();

    function getId(url){
        return(url.slice(31, 42));
    }

    function onChangehandler(e) {
        setReelUrl(e.target.value);
    }

    function submitHandler(e) {
        e.preventDefault();
        if(reelUrl.length === 0){
            alert("Empty Reel link !");
            return;
        }
        setIsLoading(true);
        fetchReel();
    }

    async function fetchReel() {

        const keyArray = [
            /*'60adc1bb24msh08b58709c254195p1ceaf9jsn702845084af7', // hannanmaxdev
        'a9180eee71msh7daf37d8a65155fp1135c4jsn69a08279cc3c', // 16bcah06
        '1fc1557c64mshac7f9f1ef7bd22ap1117f9jsn460218e2802e', // wishsweep
        'dc0b9e0c53mshdcc3d86bcee2f32p1294aajsn24e216d7fea9', // maxshare.dev
        '10f635b96bmsha0ca3a88fc4284cp1ae189jsn7c031834e744',*/ // i v
        'fac46d21e6msh47540c3dcf1efccp1826c6jsn02f539467773', // khadii143h done
        'c2854576a9mshb1ff9a9370c36f6p1e1e4bjsn387d5fc77dca', //DKMWHACKER done
        '911483c971mshdb95a4156dc5d7cp1bace1jsn1da8bf088b7f', // dipti done
        '066cbe2cd7msh36f61eefa10031dp1340c8jsna5da954d7c8c', // hmdevcoders  done
        'd8bad5a0fdmshc15f444f8342ecep19ee5ajsn04ce42f2b0df', // mantleboy629 // i . com
        'ccc41a5a88msh5db14c8020343d3p1e64a5jsn7843146453e7', // mantleboy.627
        '687d5d8f6fmsh2b1082c117dc180p143dd4jsnfb2291c54ecb' // Hannan.kananbardoli
        ];
        var randomKey = Math.floor(Math.random() * keyArray.length);

        const reelId = getId(reelUrl);
        if(reelId.length!== 11){
            alert("Invaid Reel URL");
            setIsLoading(false);
            return;
        }
        const response = await fetch(`https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/media_by_id?shortcode=${reelId}&response_type=reels&corsEnabled=true`,
            {   
                method: "GET",
                headers: {
                    "x-rapidapi-key":
                        keyArray[randomKey],
                    "x-rapidapi-host":
                        "instagram-bulk-profile-scrapper.p.rapidapi.com",
                },
            });
        const data = await response.json();
        setResponseObj(data[0]);
        setIsLoading(false);
        setHasLoaded(true);
    }

    return(
        <section id="reel-section">
            
            <SearchForm submitHandler={submitHandler} onChangehandler={onChangehandler} placeholder="Enter Reel link"/>

            <div className="reel-response">
                {isLoading && <LoadingAnimation />}
                {hasLoaded && <LoadedReels responseObj={responseObj}/>}
            </div>
        </section>
    );
};

export default Reels;
